import { removeEmptyKeys } from '../utils';
import { aliases } from './config';
/**
 * @returns - [flattenAliases]
 *
 * @example
 * const flattenAliases = flattenAliasProps();
 */

export var flattenAliasProps = function flattenAliasProps() {
  var aliasProps = [];
  Object.keys(aliases).forEach(function (alias) {
    aliasProps = [].concat(aliases[alias], aliasProps);
  });
  return aliasProps;
};
/**
 * @param {string[]} atomArray
 *
 * @returns - [atomStrings]
 *
 * @example
 * const ['m', 'mb', 'mt', 'ml', 'mr', 'my', 'mx' , 'p'] = extendAtomProps(['marginProps', 'p']);
 */

export var extendAtomProps = function extendAtomProps(atomArray) {
  var atoms = [];
  var cleanAtoms = atomArray.filter(function (item) {
    return !item.includes('Props');
  }); // Remove aliases from default props

  Object.keys(aliases).forEach(function (aliasKey) {
    if (atomArray.includes("" + aliasKey)) {
      atoms = [].concat(aliases[aliasKey], atoms);
    }
  });
  return [].concat(cleanAtoms, atoms);
};
/**
 * @param {Object} props
 * @param {string[]} allowedProps
 *
 * @returns - {}
 *
 * @example
 * const { m: 3 } = filterAllowedAtoms({ m: 3, float: 'left' }, [m', 'mb', 'mt', 'ml', 'mr', 'my', 'mx' , 'p']]);
 */

export var filterAllowedAtoms = function filterAllowedAtoms(props, allowedProps) {
  return Object.keys(props).filter(function (key) {
    return allowedProps.includes(key);
  }).reduce(function (obj, key) {
    obj[key] = props[key];
    return obj;
  }, {});
};
/**
 * @param {Object} props
 *
 * @returns - {cleanProps}
 *
 * @example
 * const { name: 'Jef' } = filterAllowedAtoms({m: 3, name: 'Jef'});
 */

export var removeAtomsFromProps = function removeAtomsFromProps(props) {
  var aliasProps = flattenAliasProps();
  return removeEmptyKeys(Object.keys(props).filter(function (key) {
    return !aliasProps.includes(key);
  }).reduce(function (obj, key) {
    obj[key] = props[key];
    return obj;
  }, {}));
};